import { useRef, useCallback, useEffect } from 'react';
import './Tilt3D.scss';

export default function Tilt3D({ children, className = '', intensity = 10 }) {
  const ref = useRef(null);

  const onMove = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const cx = (e.clientX - rect.left) / rect.width - 0.5;
    const cy = (e.clientY - rect.top) / rect.height - 0.5;
    el.style.transform =
      `perspective(800px) rotateX(${-cy * intensity}deg) rotateY(${cx * intensity}deg) scale3d(1.02,1.02,1.02)`;
    el.style.setProperty('--glare-x', `${(cx + 0.5) * 100}%`);
    el.style.setProperty('--glare-y', `${(cy + 0.5) * 100}%`);
  }, [intensity]);

  const onLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.transform = '';
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

    el.addEventListener('mousemove', onMove, { passive: true });
    el.addEventListener('mouseleave', onLeave);
    return () => {
      el.removeEventListener('mousemove', onMove);
      el.removeEventListener('mouseleave', onLeave);
    };
  }, [onMove, onLeave]);

  return (
    <div ref={ref} className={`tilt3d ${className}`}>
      {children}
    </div>
  );
}
